module.exports = __webpack_public_path__ + "img/loading.fbe6ddd4.gif";